import _ from 'lodash'

import {
  FETCH_ORGANIZATION,
  FETCH_ORGANIZATION_FAILED,
  FETCH_ORGANIZATION_SUCCEEDED,
} from './actions'

const initialState = {
  fail: false,
  load: false,
  name: null,
  org_id: null,
  created_at: null,
  config: {},
}

export const organizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORGANIZATION: {
      return {
        ...state,
        fail: false,
        load: true,
      }
    }
    case FETCH_ORGANIZATION_FAILED: {
      return {
        ..._.cloneDeep(initialState),
        fail: true,
        load: false,
        messageError: action.payload,
      }
    }
    case FETCH_ORGANIZATION_SUCCEEDED: {
      return {
        fail: false,
        load: false,
        ...action.payload,
      }
    }

    default:
      return state
  }
}

export default organizationReducer
